<template>
  <div class="login_page" id="login_page">
    <el-row class="loginPage_child">
      <el-col :xs="0" :sm="14" :md="15" :lg="16" :xl="17" class="bacgkImages"></el-col>
      <el-col :xs="24" :sm="10" :md="9" :lg="8" :xl="7" class="flexNormal">
        <div style="margin-top: 45%; min-width: 300px; max-width: 400px">
          <el-row>
            <div>
              <h3>邮箱/账号登录</h3>
              <div class="descEng">Login with email or account</div>
            </div>
            <div class="LogFailed" v-if="logisu.Faile"><i class="el-icon-error"></i>{{ logisu.msg || '账号或密码错误' }}</div>
          </el-row>
          <el-form label-width="50px" :model="loginForm" :rules="formRule" label-position="top" ref="loginForm">
            <el-form-item prop="username" label="邮箱/账号" class="form_content">
              <el-input placeholder="请输入您的邮箱/账号..." v-model="loginForm.username" class="login_input"></el-input>
            </el-form-item>
            <el-form-item class="form_content" style="margin-bottom: 15px" label="密码" prop="password">
              <el-input
                placeholder="请输入密码..."
                class="login_input"
                show-password
                :type="show.open ? 'text' : 'password'"
                v-model="loginForm.password"
                @keyup.enter.native="login('loginForm')">
              </el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 10px">
              <el-button class="login_button" :class="logisu.disabled ? 'login_scc' : ''" :loading="logisu.disabled" @click="login('loginForm')">
                {{ logisu.text }}
              </el-button></el-form-item
            >
            <el-form-item>
              <div class="flexBetween">
                <router-link to="/registerPage" :underline="false">
                  <el-link :underline="false" style="color: #0170f2 !important">企业注册</el-link>
                </router-link>
                <router-link to="/" :underline="false">
                  <el-link :underline="false" class="gray">忘记密码？</el-link>
                </router-link>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'loginPage',
  data() {
    return {
      logisu: {
        disabled: false,
        text: '登录',
        Faile: false,
        msg: null,
      },
      // bannerImg: require('../../assets/img/登录页bg.png'),
      loginForm: {
        username: '',
        password: '',
      },
      show: {
        open: false,
        check: false,
      },
      formRule: {
        username: [{ required: true, message: '请输入用户名/邮箱', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      nowLink: '',
    };
  },
  watch: {},
  mounted() {
    this.getCookie();
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logisu.disabled = true;
          this.logisu.text = '正在登录...';
          this.logisu.Faile = false;
          this.$axios
            .post('api/login/login', this.loginForm)
            .then((res) => {
              if (res.data.code == 200) {
                sessionStorage.setItem('userToken', res.data.data.token);
                let Base64 = require('js-base64').Base64; // 引用base-64加密
                let userInfo = JSON.stringify(res.data.data);
                userInfo = Base64.encode(userInfo);
                window.document.cookie = 'token=' + res.data.data.token;
                // 放入vuex中
                this.$store.dispatch('setCurrentUserFun', res.data.data);
                this.logisu.text = '登录成功，即将跳转...';
                setTimeout(() => {
                  this.$router.push('/homePage');
                  this.logisu.disabled = false;
                }, 1000);
              } else {
                this.$message.error({
                  message: res.data.msg,
                  type: 'error',
                  offset: 80,
                });
                this.logisu.disabled = false;
                this.logisu.text = '登录';
                this.logisu.Faile = true;
                this.logisu.msg = res.data.msg;
              }
            })
            .catch((err) => {
              console.log(err);
              this.logisu.disabled = false;
              this.logisu.text = '登录';
            });
        } else {
          console.log('error submit!!');
          this.logisu.disabled = false;
          this.logisu.text = '登录';
          return false;
        }
      });
    },
    /*
  点击登录调用设置上cookie  
  参数：用户名-密码-到期天数
*/
    setCookie(username = this.loginForm.username, password = this.loginForm.password, num = 7) {
      const time = new Date();
      time.setTime(time.getTime() + 24 * 60 * 60 * 1000 * num);
      //加上window.btoa是为了对用户名和密码进行编码，不让cookie明文展示
      window.document.cookie = `userName=${window.btoa(username)}; path=/; expires=${time.toGMTString()}`;
      window.document.cookie = `passWord=${window.btoa(password)}; path=/; expires=${time.toGMTString()}`;
    },

    /* 读取cookie */
    getCookie() {
      if (document.cookie.length > 0) {
        const cookieArr1 = document.cookie.split(';');
        for (let i in cookieArr1) {
          const cookieArr2 = cookieArr1[i].split('=');
          //避免输入中含有空格，消除文本框空格
          cookieArr2[0] = cookieArr2[0].replace(/\s+/g, '');
          cookieArr2[1] = cookieArr2[1].replace(/\s+/g, '');
          if (cookieArr2[0] == 'userName') {
            //读取cookie然后进行解码
            this.loginForm.username = window.atob(cookieArr2[1]);
          } else if (cookieArr2[0] == 'passWord') {
            this.loginForm.password = window.atob(cookieArr2[1]);
          } else if (cookieArr2[0] == 'nowLink') {
            this.nowLink = window.atob(cookieArr2[1]);
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.loginPage_child {
  position: relative;
  text-align: left;
  width: 100%;
  height: calc(100vh);
}

.weichai_loginPage {
  height: calc(100vh - 60px);
}

.box-card {
  width: 400px;
}

.login_page >>> .el-form-item__error {
  padding-top: 1px;
}

.colStyle {
  width: 402px;
  position: absolute;
  right: 293px;
  top: 122px;
}

.colStyle h3 {
  margin: 0;
  text-align: left;
  font-size: 18px;
  line-height: 31px;
  letter-spacing: 0.08em;
  color: #1a4769;
}

.descEng {
  font-size: 10px;
  line-height: 17px;
  letter-spacing: 0.08em;
  text-transform: capitalize;
  color: #848d9e;
  text-align: left;
  margin: 2px 0 27px 0;
  font-family: Myanmar Khyay;
  font-weight: 600;
}

/* 按钮 */
.login_button {
  width: 100%;
  height: 40px;
  padding: 0;
  border-radius: 8px;
  background: linear-gradient(134.97deg, rgba(1, 112, 242, 1) -0.27%, rgba(0, 89, 192, 1) 99.4%) !important;
  color: rgba(255, 255, 255, 100) !important;
  font-size: 13px;
  text-align: center;
  letter-spacing: 0.12em;
  border: 1px solid rgba(1, 112, 242, 1) !important;
}

.login_scc {
  background: rgb(134, 166, 189) !important;
  color: rgb(228, 244, 253) !important;
}

a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}

.el-select-dropdown__item {
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
}

.LogFailed {
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: rgba(254, 98, 98, 0.15);
  border: 1px solid #fe6262;
  border-radius: 2px;
  color: #fe6262;
  margin-bottom: 4px;
  font-size: 14px;
}

.LogFailed i {
  margin-right: 6px;
}
.bacgkImages {
  background: url('../../assets/img/登录页bg1920.png') center center / cover no-repeat;
  height: 100%;
}
</style>

<style lang="less" scoped>
/* 移动端样式 */
@media only screen and (max-width: 768px) {
  .loginPage_child {
    background: url('../../assets/img/登录页bg1920.png') center center / cover no-repeat;
    background-color: rgba(17, 23, 29, 0.65);
    background-blend-mode: multiply;
    color: #fff;
    font-weight: bolder;
    /deep/.el-form-item__label,
    .descEng,
    .gray {
      color: #fff;
      font-weight: bolder;
    }
  }
}
</style>
<style>
.form_content .el-input__inner::-webkit-input-placeholder {
  color: rgba(132, 141, 158, 0.5);
  font-size: 11px;
  line-height: 19px;
  letter-spacing: 0.04em;
  text-transform: capitalize;
}

.form_content .el-input__inner::-moz-placeholder {
  color: rgba(132, 141, 158, 0.5);
  font-size: 11px;
  line-height: 19px;
  letter-spacing: 0.04em;
  text-transform: capitalize;
}

.form_content .el-input__inner::-ms-input-placeholder {
  color: rgba(132, 141, 158, 0.5);
  font-size: 11px;
  line-height: 19px;
  letter-spacing: 0.04em;
  text-transform: capitalize;
}

.login_input .el-input__inner {
  height: 32px;
  border-radius: 2px;
}

.form_content .login_input .el-input__icon {
  line-height: 32px;
}

.colStyle .el-form--label-top .el-form-item__label {
  line-height: 20px;
  padding: 0;
  margin-bottom: 6px;
  letter-spacing: 0.08em;
  text-transform: capitalize;
  color: #848d9e;
  font-size: 13px;
}

.colStyle .form_content {
  text-align: left;
  margin-bottom: 13px;
}

.colStyle .el-form-item__content {
  line-height: 20px;
}

#login_page .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  display: none;
}

.colStyle .el-link.el-link--default,
.colStyle .el-checkbox__label {
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.08em;
  text-transform: capitalize;
  color: #848d9e !important;
}

.colStyle .el-checkbox__inner {
  width: 13px;
  height: 13px;
}

.colStyle .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #3991d2;
  border-color: #3991d2;
}
</style>
